// Copyright (c) 2016 Deere & Company

import OpenMaintenancePlan, {getDefaultState as getOpenMaintenancePlanDefaultState} from '@deere/cps-it.warranty-model-factory/lib/open-maintenance-plan';
import actions from '../../../action-list';
import {findMatchingPlan} from '../../../shared/services/claim-shared-helper';
import {getDefaultState} from '../state';

const resetSelectedOpenMaintenancePlan = () => getOpenMaintenancePlanDefaultState();

const updateSelectedOpenMaintenancePlanReadOnly = (state, action) =>
    OpenMaintenancePlan.update(state, {
        $set: action.maintenancePlanObject
    });

const updateSelectedOpenMaintenancePlan = (state, action) =>
    OpenMaintenancePlan.update(state, {
        $set: findMatchingPlan(action.planName, action.plans)
    });

export default (state = getDefaultState().selectedOpenMaintenancePlan, action) => {

    const actionTypes = {
        [actions.RESET_CLAIM_MAINTENANCE_PLAN]: resetSelectedOpenMaintenancePlan,
        [actions.UPDATE_CLAIM_MAINTENANCE_PLAN_READ_ONLY_SELECTED_OPEN_MAINTENANCE_PLAN]: updateSelectedOpenMaintenancePlanReadOnly,
        [actions.UPDATE_CLAIM_MAINTENANCE_PLAN_SELECTED_OPEN_MAINTENANCE_PLAN]: updateSelectedOpenMaintenancePlan
    };

    const reducer = actionTypes[action.type];

    return reducer ?
        reducer(state, action) :
        state;

};



// WEBPACK FOOTER //
// ./src/claim/marketing/maintenance-plan/reducers/selected-open-maintenance-plan.js